import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Download } from 'lucide-react';

/**
 * Aperçu de document (PDF ou image) dans une boîte de dialogue.
 * preview: { data: string (data URI ou URL blob:), filename: string, mimetype?: string } ou null
 *   - mimetype est nécessaire pour les URL blob: (le type ne peut pas être déduit de l'URL)
 * onClose: ferme l'aperçu
 * onDownload: optionnel, bouton de téléchargement
 */
const DocumentPreviewDialog = ({ preview, onClose, onDownload }) => {
  if (!preview) return null;

  const mimetype = preview.mimetype || '';
  const isPdf = mimetype === 'application/pdf' || preview.data?.includes('application/pdf');
  const isImage = mimetype.startsWith('image/') || preview.data?.startsWith('data:image');

  return (
    <Dialog open={!!preview} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-4xl h-[85vh] flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between gap-4 pr-8">
            <span className="truncate">{preview.filename || 'Aperçu du document'}</span>
            {onDownload && (
              <Button variant="outline" size="sm" onClick={onDownload}>
                <Download className="w-4 h-4 mr-2" />
                Télécharger
              </Button>
            )}
          </DialogTitle>
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-auto rounded-md border bg-muted/30">
          {isImage ? (
            <div className="flex items-center justify-center h-full p-4">
              <img
                src={preview.data}
                alt={preview.filename || 'Document'}
                className="max-w-full max-h-full object-contain"
              />
            </div>
          ) : isPdf ? (
            <iframe
              src={preview.data}
              title={preview.filename || 'Document'}
              className="w-full h-full"
            />
          ) : (
            <iframe
              src={preview.data}
              title={preview.filename || 'Document'}
              className="w-full h-full"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DocumentPreviewDialog;
